export interface OAuthFeatureConfig {
  app: string;
  endpointKey: string;
}

export type LoginType = 'page' | 'modal';
